import { render, staticRenderFns } from "./resellers.vue?vue&type=template&id=3fca67e6&scoped=true"
import script from "./resellers.vue?vue&type=script&lang=js"
export * from "./resellers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fca67e6",
  null
  
)

export default component.exports